export default __webpack_public_path__ + "static/media/icons-03.f8ff4a09.svg";